import { fetcher } from "helpers/fetcher";

import {
  TUpdateActiveVacancySlotReq,
  TUpdateActiveVacancySlotRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateActiveVacancySlot = async (
  payload: TUpdateActiveVacancySlotReq
) => {
  return await fetcher<
    TUpdateActiveVacancySlotRes,
    TUpdateActiveVacancySlotReq
  >(ENDPOINT.CORPORATION.UPDATE_ACTIVE_VACANCIES_SLOT, {
    data: {
      idJobListing: payload.idJobListing,
      remainingSlot: payload.remainingSlot,
    },
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_ACTIVE_VACANCIES_SLOT.version,
      [API_HEADER.CORP_ID]: payload?.idCorporation,
      [API_HEADER.BU_ID]: payload?.idBusinessUnit,
    },
  });
};

export const mutationUpdateActiveVacancySlot = async (
  payload: TUpdateActiveVacancySlotReq
) => {
  return (await updateActiveVacancySlot(payload)).data;
};

mutationUpdateActiveVacancySlot._key = (
  payload: TUpdateActiveVacancySlotReq
) => [ENDPOINT.CORPORATION.UPDATE_ACTIVE_VACANCIES_SLOT.url, payload];
